export default "<p>\r\n  pedidos works!\r\n</p>\r\n";